import { ActionTypes } from "../Constant/ActionType.tsx";
import { Increment, NotificationDataState, NotificationState } from "./Interface/Interface.tsx";

const initialStateTotalNotification: NotificationState = {
  totalNotification: 0,
};

const initialStateNotificationDetials: NotificationDataState = {
  notifications: []
}

const initialIndex : Increment = {
  index:1
}

export const totalNotificaitonReducer = (state = initialStateTotalNotification, { type, payload }) => {
  switch (type) {
    case ActionTypes.TOTAL_NOTIFICATION:
      return {
        totalNotification: payload,
      };
    default:
      return state;
  }
};

export const setTotalNotificationsReducer = (state = initialStateNotificationDetials, { type, payload }) => {
  switch (type) {
    case ActionTypes.SET_NOTIFICATION:
      return {
        notifications: [...payload],
      };
    default:
      return state;
  }
} 


export const incrementIndexForNotification = (state = initialIndex, {type, num}) => {
  switch (type){
    case ActionTypes.INCREMENT:
      return {index: num + 1};
    default:
      return state;
  }
}